import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable({
    providedIn: 'root',
})
export class LoaderInterceptor implements HttpInterceptor {
    private requestCount = 0;

    constructor(private loadingService: LoadingService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requestCount++;
        this.loadingService.setLoading(true);

        return next.handle(req).pipe(
            finalize(() => {
                if (this.requestCount > 0) this.requestCount--;
                if (this.requestCount == 0) this.loadingService.setLoading(false);
            })
        );
    }
}
